import { TemplateResult, html, CSSResultGroup } from 'lit';
import { customElement } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import componentStyles from './tufts-table.css.lit';

/**
 * The Tufts Table component
 * @element tufts-table
 *
 * @slot - a default slot
 */
@customElement('tufts-table')
export class tuftsTable extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];
  ngSlot = new SlotNGController(this);

  render(): TemplateResult {
    return html` <section>${this.ngSlot.renderInShadow()}</section> `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-table': tuftsTable;
  }
}
